import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const MenuLink = React.forwardRef(({ id, label, Icon, href, path, disabled, ariaLabel, target }, ref) => {
  if (!href) { // Maybe provided later as part of some metadata not loaded yet
    return (
      <MenuItem ref={ref} id={id} aria-label={ariaLabel || label}>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={label} />
      </MenuItem>
    );
  }
  return (
    <MenuItem
      component="a"
      href={`${href}${path || ''}`}
      target={target === 'none' ? undefined : target}
      rel="noreferrer noopener"
      ref={ref}
      aria-label={ariaLabel || label}
      id={id}
      disabled={disabled}
    >
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );
});

MenuLink.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]).isRequired,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  path: PropTypes.string,
  disabled: PropTypes.bool,
};

MenuLink.defaultProps = {
  id: undefined,
  href: undefined,
  path: undefined,
  target: '_blank',
  ariaLabel: undefined,
  disabled: undefined,
};

export default MenuLink;
